{
  "admin.login.redirecting": "Redirecting to sign-in…",
  "admin.portal.title": "Admin",
  "admin.portal.heading": "Welcome!",
  "admin.portal.tagline": "Choose what you want to do.",
  "admin.portal.tile.brandLine": "OMA+",
  "admin.portal.tile.service.line": "service",
  "admin.portal.tile.cms.line": "content management",
  "admin.portal.tile.analytics.line": "analytics",
  "admin.portal.tile.feedback.line": "feedback",
  "admin.portal.tile.analytics.unavailable": "Not yet available",
  "admin.feedback.heading": "OMA+ feedback",
  "admin.feedback.backToPortal": "Back",
  "admin.feedback.filter.last24Hours": "Last 24 hours",
  "admin.feedback.filter.lastWeek": "Last week",
  "admin.feedback.filter.lastMonth": "Last month",
  "admin.feedback.filter.lastSixMonths": "Last 6 months",
  "admin.feedback.filter.all": "All",
  "admin.feedback.filter.custom": "Custom range",
  "admin.feedback.filter.from": "From",
  "admin.feedback.filter.to": "To",
  "admin.feedback.filter.legend": "Time period",
  "admin.feedback.filter.customSelected": "Custom range: {range}",
  "admin.feedback.filter.apply": "Apply dates",
  "admin.feedback.filter.cancel": "Cancel",
  "admin.feedback.filter.validation.missing": "Enter valid start and end dates.",
  "admin.feedback.filter.validation.reversed": "Start date must not be after end date.",
  "admin.feedback.filter.validation.future": "Future dates cannot be selected.",
  "admin.feedback.filter.calendar.selectFromInstruction": "Select a start date from the calendar.",
  "admin.feedback.filter.calendar.selectToInstruction": "Select an end date from the calendar.",
  "admin.feedback.filter.calendar.fromTo": "Start and end date",
  "admin.feedback.filter.calendar.previousMonth": "Previous month",
  "admin.feedback.filter.calendar.nextMonth": "Next month",
  "admin.feedback.filter.calendar.weekdays": "Mo Tu We Th Fr Sa Su",
  "admin.feedback.export": "Export to Excel",
  "admin.feedback.exportPending": "Preparing Excel workbook…",
  "admin.feedback.exportFailed": "Excel export failed. Please try again.",
  "admin.feedback.summary.heading": "Feedback summary",
  "admin.feedback.stat.count": "Feedback entries",
  "admin.feedback.stat.average": "Average (1–5)",
  "admin.feedback.stat.satisfied": "Satisfied (4–5)",
  "admin.feedback.stat.dissatisfied": "Dissatisfied (1–2)",
  "admin.feedback.stat.withText": "With text",
  "admin.feedback.noRatings": "Data not available",
  "admin.feedback.noComparison": "No comparison",
  "admin.feedback.change.up": "Numerically increased",
  "admin.feedback.change.down": "Numerically decreased",
  "admin.feedback.change.neutral": "No numerical change",
  "admin.feedback.change.percentagePoints": " percentage points",
  "admin.feedback.period.disclosure": "Month means 30 elapsed days. Six months means 180 elapsed days.",
  "admin.feedback.period.finnishTime": "Finnish time",
  "admin.feedback.period.details": "Period details",
  "admin.feedback.period.selected": "Selected period",
  "admin.feedback.period.reference": "Comparison period",
  "admin.feedback.period.allRetained": "All retained feedback",
  "admin.feedback.period.allRetainedUntil": "All retained feedback until",
  "admin.feedback.period.timeZone": "Time zone Europe/Helsinki. The end boundary is excluded.",
  "admin.feedback.metric.open": "View details",
  "admin.feedback.metric.back": "Back",
  "admin.feedback.metric.values": "Data table",
  "admin.feedback.metric.period": "Period",
  "admin.feedback.metric.missingObservations": "Dashed line: no ratings in between.",
  "admin.feedback.metric.contributors.count": "All feedback in the selected period",
  "admin.feedback.metric.contributors.averageRating": "Rated feedback in the selected period",
  "admin.feedback.metric.contributors.satisfiedPercentage": "Satisfied feedback (4–5) in the selected period",
  "admin.feedback.metric.contributors.dissatisfiedPercentage": "Dissatisfied feedback (1–2) in the selected period",
  "admin.feedback.metric.contributors.withTextCount": "Feedback with text in the selected period",
  "admin.feedback.metric.unit.count": "count",
  "admin.feedback.metric.unit.averageRating": "scale 1–5",
  "admin.feedback.metric.unit.percentage": "percent, scale 0–100",
  "admin.feedback.metric.granularity.hour": "Hourly",
  "admin.feedback.metric.granularity.day": "Daily",
  "admin.feedback.metric.granularity.week": "Weekly",
  "admin.feedback.metric.granularity.month": "Monthly",
  "admin.feedback.metric.grouped.hour": "Hourly, every {n} hours",
  "admin.feedback.metric.grouped.day": "Daily, every {n} days",
  "admin.feedback.metric.grouped.week": "Weekly, every {n} weeks",
  "admin.feedback.metric.grouped.month": "Monthly, every {n} months",
  "admin.feedback.table.date": "Date",
  "admin.feedback.table.rating": "Rating",
  "admin.feedback.table.text": "Feedback",
  "admin.feedback.table.heading": "All feedback in the selected period",
  "admin.feedback.noRating": "No rating",
  "admin.feedback.noText": "No feedback text",
  "admin.feedback.loading": "Loading…",
  "admin.feedback.empty": "No feedback in the selected period.",
  "admin.feedback.error": "Could not load feedback.",
  "admin.cms.backToPortal": "Main menu",
  "admin.forbidden.heading": "Admin – not real",
  "admin.forbidden.body": "This is a demo-build placeholder. The demo does not model real authorisation and contains no admin functionality. The actual admin surface is a separate production service and is not part of this demo.",
  "admin.forbidden.navigation": "Return via the primary navigation above."
}
